import ForwardIcon from "@mui/icons-material/Forward";
import { HashLink as Link } from "react-router-hash-link";
import "./ApplicationCardButton.css";

function ApplicationCardButton({ to }) {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <Link to={to} onClick={handleClick}>
      <button className="application-card-button">
        <span className="application-card-button-text">Részletek</span>
        <div className="application-card-button-arrow">
          <ForwardIcon />
        </div>
      </button>
    </Link>
  );
}

export default ApplicationCardButton;
